module.exports = __webpack_public_path__ + "static/media/bootstrap.79c2c416.svg";